import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDestroyProcoreIdentityMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(
        `/integrations/procore_identities/${id}`,
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.setQueryData(
        ['integrations', 'procoreIdentity'],
        (_existingDomainProcoreIdentity) => ({ data: null }),
      );
      queryClient.setQueryData(
        ['procore', 'user'],
        (_existingDomainProcoreUser) => ({
          data: null,
          meta: { requestStatus: 'completed' },
        }),
      );
    },
  });
}
